import { TmApiError } from "@classifieds-sell/datalayer";

const SERVER_ERROR_HTTP_CODE = 500;

export function isApiError(error: Error): error is TmApiError {
    const tmError = error as any;
    return (
        tmError &&
        typeof tmError.status === 'number' &&
        typeof tmError.statusText === 'string' &&
        tmError.data !== undefined
    );
}

export function getErrorMessage(error: Error): string {
    // Try to expose a sensible error message where possible
    if (
        error &&
        isApiError(error) &&
        error.status < SERVER_ERROR_HTTP_CODE &&
        error.data.errorMessage
    ) {
        return error.data.errorMessage;
    }

    return error.message;
}
